// Pendiente de revisar
import { ItiBaseDto } from "@/iti-core-react/dtos/iti-base-dto";
import { AttributeDefsDto } from "./attribute-defs-dto";

export class CategoryDto extends ItiBaseDto {
	public name: string;
	public description?: string;
	public parent?: string;
	public attributeDefs?: AttributeDefsDto[];
	public artifacts?: number;
	public datasets: number;

	constructor(src?: any) {
		super(src, true);
		Object.assign(this, src);

		if (src) {
			this.attributeDefs = src?.attributeDefs?.map(
				(c: AttributeDefsDto) => new AttributeDefsDto(c),
			);
		}
	}
}

export class CategoryDtoV2 extends ItiBaseDto {
	description: string;
	parent: string;
	title: string;
	resources: number;
	glossaries: number;
	isExpanded?: boolean;

	constructor(src?: any) {
		super(src, true);
		Object.assign(this, src);
	}
}
